import React from 'react';
import PropTypes from 'prop-types';

import { parseISO, formatDistanceToNow } from 'date-fns';
import pt from 'date-fns/locale/pt';

import { IoMdCalendar, IoMdImage } from 'react-icons/io';

import {
  Container,
  Image,
  Overlay,
  Footer,
  Text,
  Date,
  DateText,
} from './styles';

function BloodItem({ item, setActive }) {
  const { region, image, created_at } = item;

  const dateParsed = formatDistanceToNow(parseISO(created_at), {
    locale: pt,
    addSuffix: true,
  });

  return (
    <Container onClick={() => setActive(item)}>
      {image ? <Image src={image.url} /> : <IoMdImage />}
      {image && <Overlay />}

      <Footer>
        <Text>{region}</Text>
        <Date>
          <IoMdCalendar color="#0384ac" />
          <DateText>{dateParsed}</DateText>
        </Date>
      </Footer>
    </Container>
  );
}

BloodItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    created_at: PropTypes.string,
    drug: PropTypes.shape({
      factor: PropTypes.string,
    }),
  }).isRequired,
  setActive: PropTypes.func.isRequired,
};

export default BloodItem;
